import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { AuthLayout, ButtonBlockPrimary } from "../components";
import { useNavigate } from "react-router-dom";
import { showMessage } from "../utls/message";
import { signUp } from "../service/authService";

const TermOfCondition = () => {
  const { registerForm } = useSelector(
    (state: RootState) => state.reducer.utlsSlice,
  );
  const [aggre, setAggre] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const radioRef = useRef<HTMLInputElement>(null);

  const handleLabelClick = () => {
    if (radioRef.current) {
      radioRef.current.click();
      setAggre(!aggre);
    }
  };

  const handleCheckboxChange = () => {
    handleLabelClick();
  };

  const navigate = useNavigate();

  const onSubmit = async () => {
    if (!registerForm.register) {
      showMessage("Form Not Complited", "error");
      navigate("/register");
    } else {
      if (isLoading) {
        return;
      }

      if (aggre) {
        setIsLoading(true);
        const response = await signUp(registerForm);
        setIsLoading(false);
        console.log(response);
        if (response.code > 300) {
          if (response.message.includes("cmn_users.UniqueIdentityNumber2")) {
            showMessage("No KK is already used", "error");
            return;
          }

          if (response.message.includes("cmn_users.UniqueIdentityNumber")) {
            showMessage("NIK is already used", "error");
            return;
          }

          if (response.message.includes("cmn_users.UniqueCode")) {
            showMessage("Code is already used", "error");
            return;
          }
          if (response.message.includes("cmn_users.UniqueEmail")) {
            showMessage("Email is already used", "error");
            return;
          }

          showMessage(response.message, "error");
        } else {
          navigate("/auth");
        }
      } else {
        showMessage("Ceck Term Of Condition", "error");
      }
    }
  };

  return (
    <AuthLayout showNavBar={true} title="Term Of Condition">
      <div className="pt-16 pb-4">
        <div className="font-bold grid text-center justify-items-center ">
          <h1>Selamat datang di SR12 Herbal Kosmetik</h1>
          {/* <h1>SYARAT DAN KETENTUAN</h1>
          <h2>Kemitraan</h2>
          <h3>PT. SR12 Herbal Kosmetik</h3>
          <span className="mt-10 mb-5">Pendahuluan</span> */}
        </div>
        <div className="box-syarat prose lg:prose-lg">
          <p>
            {/* text term start  */}
            <div className="grid text-center justify-items-center py-2">
              <h1 className="text-[20px] font-medium">SYARAT DAN KETENTUAN</h1>
              <h3 className="text-[14px] font-medium">
                PT. SR12 Herbal Kosmetik
              </h3>
            </div>

            <p>
              Selamat datang di SR12 Herbal Kosmetik (dalam hal ini disebut
              &ldquo;SR12&rdquo;).
            </p>
            <p>
              Silakan baca Syarat dan Ketentuan Mitra SR12 berikut ini dengan
              cermat sebelum menggunakan aplikasi atau membuka akun agar Anda
              mengetahui tentang hak dan kewajiban hukum Anda sehubungan dengan
              PT SR12 Herbal Kosmetik, seluruh Mitra, dan mitra lainnya.
            </p>
            <p>
              Semua informasi, halaman tertaut, fitur, data, teks, gambar, foto,
              grafik, pesan, tag, konten, pemrograman, perangkat lunak, layanan
              aplikasi, atau materi lainnya yang tersedia melalui aplikasi atau
              layanan terkait merupakan bagian dari layanan SR12.
            </p>
            <p>
              Setiap produk baru yang ditambahkan atau memperbesar jangkauan
              juga tunduk pada Syarat dan Ketentuan ini.
            </p>
            <p>
              Sebelum menjadi Mitra, Anda harus membaca dan menerima semua
              syarat dan ketentuan dalam dan yang berkaitan dengan syarat ini,
              dan Anda harus memberikan persetujuan atas pemrosesan data pribadi
              Anda sebagaimana dijelaskan dalam Kebijakan Privasi yang terkait
              dengan syarat layanan ini.
            </p>
            <p>
              Kami berhak untuk mengganti, mengubah, menangguhkan, atau
              menghentikan semua atau bagian apa pun dari aplikasi atau layanan
              ini setiap saat atau setelah memberikan
            </p>
            <p>
              pemberitahuan sebagaimana dipersyaratkan oleh undang-undang dan
              peraturan setempat.
            </p>
            <p>
              Kami juga dapat membatasi fitur tertentu atau membatasi akses Anda
              ke bagian atau seluruh aplikasi atau layanan atas kebijakannya
              sendiri dan tanpa pemberitahuan atau kewajiban.
            </p>
            <p>
              Kami berhak untuk menolak memberikan akses ke aplikasi atau
              layanan ini kepada Anda atau mengizinkan Anda untuk membuka akun
              Mitra dengan alasan apa pun.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Privasi</h1>
            <p>Privasi Anda sangatlah penting bagi kami.</p>
            <p>
              Untuk melindungi hak-hak Anda, silakan baca syarat ini untuk
              memahami bagaimana Kami mengumpulkan dan menggunakan informasi
              yang berkaitan dengan Mitra dan/atau
            </p>
            <p>
              penggunaan layanan. Dengan menggunakan layanan atau memberikan
              informasi di aplikasi Mitra, Anda:
            </p>
            <ul className="!text-black">
              <li className="!text-black">
                menyetujui tindakan SR12 untuk mengumpulkan, menggunakan,
                mengungkapkan, dan/atau mengolah konten, data pribadi, dan
                informasi pengguna Anda sebagaimana dijelaskan dalam Kebijakan
                Privasi;
              </li>
            </ul>
            <p className="demoTitle">&nbsp;</p>
            <ul className="!text-black">
              <li className="!text-black">
                menyetujui dan mengakui bahwa hak kepemilikan atas informasi
                pengguna dimiliki secara bersama oleh Anda dan SR12; dan
              </li>
              <li className="!text-black">
                tidak akan, baik secara langsung maupun tidak langsung,
                mengungkapkan informasi pengguna Anda kepada setiap pihak
                ketiga, atau sebaliknya memperbolehkan setiap pihak ketiga untuk
                mengakses atau menggunakan informasi pengguna Anda, tanpa
                persetujuan tertulis sebelumnya dari
              </li>
            </ul>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Merek Dagang, Akun, dan Situs Web Pemasaran</h1>
            <p>
              Merek dagang dan logo SR12 Herbal Skincare memiliki hak cipta dan
              terdaftar sesuai ketentuan undang-undang yang berlaku.
            </p>
            <p>
              Mitra tidak diperbolehkan menggunakan merek dagang dan logo SR12
              untuk keperluan
            </p>
            <p>
              komersial atau untuk mendapatkan keuntungan berupa pembuatan
              produk untuk dijual tanpa seizin dari perusahaan, dalam hal ini
              Sales Department.
            </p>
            <p>
              Akun media sosial tidak boleh menyerupai akun resmi perusahaan dan
              merek resmi perusahaan &ldquo;SR12 Herbal Skincare&rdquo;. Akun
              Mitra sebaiknya melampirkan nama kota atau area tempat
            </p>
            <p>distributor berada.</p>
            <p>
              Mitra dilarang membuat atau memiliki situs web dengan nama yang
              identik dengan situs web perusahaan. Saat ini perusahaan telah
              memiliki situs web resmi{" "}
              <a href="http://www.sr12herbalskincare.co.id/">
                www.sr12herbalskincare.co.id.
              </a>
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Kemitraan</h1>
            <p>
              Kemitraan dalam SR12 Herbal Kosmetik dibagi menjadi beberapa
              tingkatan yang mana tingkatan tersebut akan ada proses perubahan
              di setiap bulannya sesuai dengan performa Mitra SR12.
            </p>
            <p>Adapun tingkatan kemitraan SR12 sendiri terdiri atas:</p>
            <ul className="!text-black">
              <li className="!text-black">Distributor</li>
              <li className="!text-black">Agen</li>
              <li className="!text-black">Subagen</li>
              <li className="!text-black">Reseller</li>
              <li className="!text-black">Marketer</li>
            </ul>
            <p>
              Setiap Mitra yang telah mendaftarkan diri akan mendapatkan Nomor
              Keanggotaan sebagai identitas Mitra SR12.
            </p>
            <p className="demoTitle">&nbsp;</p>
            <p>
              Mitra tidak memiliki hubungan kekerabatan kekeluargaan
              (istri/suami/orang tua/anak kandung, saudara kandung) dengan
              manajemen, karyawan, ataupun sesama Mitra SR12.
            </p>
            <p>
              Mitra wajib menjaga nama baik perusahaan serta memberi kritik
              dengan tujuan kebaikan bersama.
            </p>
            <p>
              Mitra wajib memberikan informasi data diri dengan benar dan
              lengkap. Apabila ditemukan pemalsuan data dan bentuk kecurangan
              lain, maka perusahaan berhak melakukan sanksi kepada Mitra SR12.
            </p>
            <p>
              Mitra tidak sedang tersangkut pada kasus hukum ataupun proses
              hukum lainnya. Jika di kemudian hari Mitra SR12 tersangkut kasus
              atau proses hukum, maka SR12 berhak untuk menentukan status Mitra
              SR12.
            </p>
            <p>
              Ketentuan lainnya akan diatur dalam perjanjian, kode etik, ataupun
              bentuk tertulis lainnya.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Pengajuan Kemitraan SR12</h1>
            <p>
              Calon Mitra harus memenuhi persyaratan dan ketentuan dalam
              pengajuan status kemitraan SR12.
            </p>
            <p>
              Adapun syarat dan ketentuan untuk pengajuan kemitraan SR12 sebagai
              berikut:
            </p>
            <ul className="!text-black">
              <li className="!text-black">
                mencapai minimal order pertama calon Mitra yang telah
                ditentukan;
              </li>
              <li className="!text-black">
                mencapai minimal omzet untuk pengajuan peningkatan status
                kemitraan;
              </li>
              <li className="!text-black">
                memenuhi kriteria dan penilaian yang akan dilakukan selama
                pengajuan kemitraan SR12;
              </li>
              <li>syarat dan ketentuan lainnya yang diatur oleh</li>
            </ul>
            <p>
              Pengajuan status kemitraan SR12 akan diajukan oleh leader dari
              setiap jaringan tim Mitra Distributor SR12.
            </p>
            <p>
              Apabila dalam masa penilaian setiap bulannya terdapat peningkatan
              atau penurunan performa omzet, status kemitraan SR12 selanjutnya
              akan dipertimbangkan oleh SR12.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Transaksi</h1>
            <p>
              Proses transaksi jual beli produk SR12 kepada Mitra dilakukan
              kepada Distributor oleh perusahaan secara langsung.
            </p>
            <p className="demoTitle">&nbsp;</p>
            <p>
              Untuk Mitra selain Distributor, transaksi jual beli dilakukan
              kepada Distributor di masing-masing jaringan timnya dan berlaku
              kepada Agen, Subagen, Reseller, dan Marketer.
            </p>
            <p>
              Dalam hal terjadi permasalahan dalam alur proses jual beli produk
              SR12 pada Distributor, wajib untuk melaporkan kepada perusahaan
              sebagai bentuk pertanggungjawaban.
            </p>
            <p>
              Seluruh tanggung jawab atas permasalahan dalam alur proses jual
              beli produk SR12 di luar Distributor (Agen, Subagen, dan lainnya)
              menjadi tanggung jawab Distributor sepenuhnya dengan adanya
              notifikasi kepada perusahaan.
            </p>
            <p>
              Seluruh Mitra bertanggung jawab penuh atas segala transaksi yang
              dilakukan.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Hadiah Apresiasi</h1>
            <ul className="!text-black">
              <li className="!text-black">
                Mitra Distributor berhak mendapatkan Hadiah Apresiasi apabila
                telah memenuhi syarat omzet dan pembinaan;
              </li>
              <li className="!text-black">
                ketentuan lain terkait Hadiah Apresiasi yang belum tercantum
                akan dibuat dalam ketentuan khusus.
              </li>
            </ul>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Hak dan Kewajiban Mitra Distributor SR12 Hak</h1>
            <ul>
              <li className="!text-black">
                mendapatkan kesempatan dan hak yang sama dari perusahaan tanpa
                adanya perbedaan antara distributor satu dan lainnya berupa
                informasi kemitraan secara utuh dan
              </li>
            </ul>
            <p>menyeluruh;</p>
            <ul className="!text-black">
              <li className="!text-black">
                mendapatkan pembinaan dan pelatihan berupa konsultasi online dan
                offline (jika memungkinkan) untuk mendapatkan distributor yang
                berkualitas;
              </li>
              <li className="!text-black">
                mengembangkan kegiatan bisnis ke seluruh Indonesia maupun luar
                negeri;
              </li>
              <li className="!text-black">
                bekerja sama dengan pihak lain (individu atau badan usaha) dalam
                mengelola usaha dengan sebelumnya melaporkan kegiatan kerja sama
                tersebut kepada perusahaan;
              </li>
              <li className="!text-black">
                mendapatkan informasi dan pengetahuan produk dari perusahaan
                jika terjadi
              </li>
            </ul>
            <p>
              perubahan seperti perubahan kemasan, komposisi, manfaat, dan
              sebagainya dalam bentuk tertulis;
            </p>
            <ul className="!text-black">
              <li className="!text-black">
                mendapatkan materi promosi berupa foto produk, konten video, dan
                gambar melalui media resmi perusahaan;
              </li>
            </ul>
            <p className="demoTitle">&nbsp;</p>
            <ul className="!text-black">
              <li className="!text-black">
                berhak mengikuti kegiatan perusahaan berupa training, pelatihan,
                gathering, dan sebagainya secara gratis maupun berbayar kepada
                perusahaan;
              </li>
              <li className="!text-black">
                mendapatkan jaminan kemasan dan kualitas produk selama 30 hari
                dengan ketentuan apabila produk yang telah dibeli mengalami
                kerusakan (cacat produksi) berdasarkan adanya surat resmi
              </li>
            </ul>
            <p>
              Jaminan kemasan dan kualitas produk diatur dengan mekanisme
              sebagai berikut:
            </p>
            <ul className="!text-black">
              <li className="!text-black">
                menunjukkan bukti invoice atau faktur pembelian produk yang sah;
              </li>
              <li className="!text-black">
                telah melunasi pembelian dan dibuktikan berdasarkan data tim
                keuangan
              </li>
            </ul>
            <h1>Kewajiban</h1>
            <ul className="!text-black">
              <li className="!text-black">
                mematuhi segala peraturan yang telah dan akan ditetapkan
                perusahaan yang tercantum dalam Syarat dan Ketentuan, peraturan,
                surat keputusan, surat pemberitahuan, dan ketetapan resmi
                lainnya yang dikeluarkan secara tertulis;
              </li>
              <li className="!text-black">
                menjelaskan dengan baik, benar, dan lengkap kepada tim di
                bawahnya mengenai kode etik dan peraturan kemitraan, sistem
                kemitraan, sharing profit, dan reward yang telah ditetapkan oleh
                perusahaan;
              </li>
              <li className="!text-black">
                menjual dan memperbelikan produk-produk SR12 kepada khalayak
                masyarakat;
              </li>
              <li className="!text-black">
                menjual produk sesuai dengan yang telah ditetapkan, tidak
                menurunkan harga tanpa adanya persetujuan atau ketetapan resmi
                dari perusahaan;
              </li>
              <li className="!text-black">
                menjaga hubungan baik sesama Mitra dan manajemen untuk menjalin
                keharmonisan dan kelangsungan bisnis yang
              </li>
            </ul>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Ketentuan Sanksi</h1>
            <p>
              Sanksi diberikan kepada Mitra yang melakukan pelanggaran terhadap
              Syarat dan Ketentuan, serta peraturan yang berlaku.
            </p>
            <p>
              Pemberian sanksi tertulis tidak wajib berurutan tetapi dapat
              langsung diberikan sesuai tingkatan berat kesalahan atau
              pelanggaran.
            </p>
            <p>
              Ketentuan lainnya akan diatur dalam perubahan, peraturan, atau
              perjanjian lainnya.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Ketentuan Lain</h1>
            <p className="demoTitle !text-black">&nbsp;</p>
            <ul className="!text-black">
              <li className="!text-black">
                akun marketplace tidak boleh menyerupai akun resmi perusahaan
                dan merek resmi
              </li>
            </ul>
            <p>
              perusahaan &ldquo;SR12 Herbal Skincare&rdquo;. Akun Mitra
              sebaiknya melampirkan nama kota atau area tempat distributor{" "}
              berada;
            </p>
            <ul className="!text-black">
              <li className="!text-black">
                harga jual produk ke konsumen secara online dan offline dengan
                pembayaran tunai maupun melalui marketplace tidak diperbolehkan
                dijual di bawah harga yang telah ditentukan perusahaan (harga
                katalog atau brosur resmi);
              </li>
              <li>
                pembinaan adalah bentuk perhatian yang dilakukan oleh leader
                kepada timnya berupa interaksi langsung maupun tidak langsung{" "}
                untuk membantu mengembangkan diri dan mendapatkan solusi dari
                permasalahan yang dihadapi tim;
              </li>
              <li className="!text-black">
                pembinaan dilakukan oleh distributor ke agen, subagen, reseller,
                dan marketer;
              </li>
              <li className="!text-black">
                ketentuan lainnya akan diatur dalam peraturan tambahan atau
              </li>
            </ul>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Pembaruan</h1>
            <p>
              Syarat dan ketentuan mungkin diubah dan/atau diperbarui dari waktu
              ke waktu tanpa pemberitahuan sebelumnya.
            </p>
            <p>
              SR12 menyarankan agar Anda membaca secara saksama dan memeriksa
              halaman syarat dan ketentuan ini dari waktu ke waktu untuk
              mengetahui perubahan apa pun atau membaca Kode Etik dan Peraturan
              Kemitraan yang terbaru.
            </p>
            <p>
              Dengan tetap mengakses dan menggunakan produk SR12, maka Mitra
              dianggap menyetujui perubahan-perubahan dalam Syarat dan
              Ketentuan.
            </p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
            <h1>Penutup</h1>
            <p>
              Dengan menggunakan atau menjadi Mitra SR12, Anda memberikan
              penerimaan dan
            </p>
            <p>
              persetujuan yang tidak dapat dicabut atas persyaratan perjanjian
              ini, termasuk syarat dan ketentuan tambahan serta kebijakan yang
              disebutkan di sini dan/atau terkait di sini.
            </p>
            <p>
              Apabila Anda tidak menyetujui ketentuan ini, mohon jangan
              menggunakan layanan kami atau mengakses aplikasi.
            </p>
            <p>
              Apabila Anda di bawah usia 17 tahun atau belum menikah dan berada
              di bawah pengampuan, Anda harus mendapatkan izin dari orang tua
              atau wali untuk membuka akun dan orang tua atau wali tersebut
              harus menyetujui ketentuan perjanjian ini.
            </p>
            <p className="demoTitle">&nbsp;</p>
            <p>
              Apabila Anda tidak memahami bagian ini, mohon jangan membuat akun
              sampai Anda telah meminta bantuan orang tua atau wali Anda.
            </p>
            <p>
              Apabila Anda adalah orang tua atau wali anak di bawah umur yang
              membuat akun, Anda harus menerima ketentuan perjanjian ini atas
              nama anak di bawah umur tersebut dan Anda akan
            </p>
            <p>
              bertanggung jawab atas semua penggunaan akun atau layanan
              perusahaan yang menggunakan akun tersebut, baik apakah akun
              tersebut sudah dibuka saat ini atau dibuat di masa mendatang.
            </p>
            <p>
              Saya telah membaca perjanjian ini dan menyetujui semua ketentuan
              yang tercantum di atas dan setiap revisi yang dilakukan atasnya
              sesudahnya.
            </p>
            <p>
              Dengan mengklik tombol menyetujui dan/atau mencentang kotak
              persetujuan (tick mark), saya memahami bahwa saya sedang membuat
              tanda tangan digital, yang saya maksudkan untuk
            </p>
            <p>
              memiliki kekuatan dan akibat yang sama seperti bila saya
              menandatangani nama saya secara manual.
            </p>

            {/* text term end   */}
          </p>
        </div>

        <div
          className="flex my-5 gap-5 cursor-pointer items-start"
          onClick={() => {
            handleLabelClick();
          }}
        >
          <input
            ref={radioRef}
            type="checkbox"
            className="check-btn"
            name="syarat"
            onChange={() => {
              handleCheckboxChange();
            }}
          />
          Dengan ini saya menyetujui semua syarat dan ketentuan yang berlaku
        </div>
        <div className="my-8">
          <ButtonBlockPrimary
            onClick={() => {
              onSubmit();
            }}
            label="Daftar"
          />
        </div>
      </div>
    </AuthLayout>
  );
};

export default TermOfCondition;
